import React from 'react';

interface HambergerMenuProps {
  isOpen?: boolean;
  onClick?: () => void;
  className?: string;
}

export const HambergerMenu: React.FC<HambergerMenuProps> = ({ isOpen = false, onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`relative size-6 cursor-pointer border-none bg-transparent p-0 ${className}`}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
    >
      <span
        className={`absolute right-0 block bg-current transition-all duration-200 ease-in-out ${
          isOpen ? 'top-1/2 -translate-y-1/2 rotate-45' : 'top-1/6'
        }`}
        style={{
          width: isOpen ? '100%' : '100%',
          height: '2px',
        }}
      />
      <span
        className={`absolute top-1/2 right-0 block -translate-y-1/2 bg-current transition-all duration-100 ease-in-out ${
          isOpen ? 'opacity-0' : 'opacity-100'
        }`}
        style={{
          width: isOpen ? '0%' : '40%',
          height: '2px',
        }}
      />
      <span
        className={`absolute right-0 block bg-current transition-all duration-200 ease-in-out ${
          isOpen ? 'top-1/2 -translate-y-1/2 -rotate-45' : 'bottom-1/6'
        }`}
        style={{
          width: isOpen ? '100%' : '70%',
          height: '2px',
        }}
      />
    </button>
  );
};
